/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_View_ReportsInputs */

const vi_dashboard_view_reports = /** @type {(inputs: Dashboard_View_ReportsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem báo cáo`)
};

/**

* @param {Dashboard_View_ReportsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_view_reports = /** @type {((inputs?: Dashboard_View_ReportsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_View_ReportsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_view_reports(inputs)
});